import React from 'react';
import { FDIcon, FDTitleText } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder, getBorderRadius } from 'Components/utils';

const useStyles = buildUseStyles('ResolvedQuestions', (theme) => ({
  root: {
    ...getBorderRadius(theme.radius.md, { all: true }),
    ...getBorder(theme, { all: true }),
    '& > *': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(3),
    },
    '& > * + *': {
      ...getBorder(theme, { top: true }),
    },
  },
  checked: {
    '& > *': {
      textDecoration: 'line-through',
    },
  },
}));

export function ResolvedQuestions({ onChange, value: valueProp, options }) {
  const classes = useStyles();
  const value = new Set(valueProp || []);
  return (
    <div className={classes.root}>
      {options.map(({ name, value: id }) => (
        <a
          key={id}
          href="#"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (value.has(id)) {
              value.delete(id);
              onChange(Array.from(value));
              return;
            }
            value.add(id);
            onChange(Array.from(value));
          }}
        >
          <FDIcon icon={value.has(id) ? 'checkCircleOutlinedIcon' : 'circleOutline'} />
          <span className={value.has(id) ? classes.checked : undefined}>
            <FDTitleText size="lg" value={name} />
          </span>
        </a>
      ))}
    </div>
  );
}
